import { refundFormInitialisation } from '../../components/refund_form';
import { ARP_NAVIGATION_EVENTS } from '../../event_bus_modules/auction_registration_navigation';

$(() => {
  const userBankDetailsCountrySelect = $('#user-bank-details-country-select');
  const USER_BANK_DETAILS_FORM_PER_COUNTRY = {
    ireland: $('#bank-transfer-user-details-form-ireland-cyprus'),
    cyprus: $('#bank-transfer-user-details-form-ireland-cyprus'),
    'south africa': $('#bank-transfer-user-details-form-south-africa'),
    spain: $('#bank-transfer-user-details-form-spain'),
    'united kingdom': $('#bank-transfer-user-details-form-united-kingdom'),
  };

  const countryOfAuction = $('#country-of-auction').val()?.toLowerCase();
  const currentCountryName = $('#selected-country-name').val()?.toLowerCase();
  const nextButton = $('#next-navigation');
  const backButton = $('#back-navigation');

  nextButton.add(backButton).on('click', () => {
    EVENT_BUS.dispatch(ARP_NAVIGATION_EVENTS.NAVIGATION_BUTTON_CLICK);
  });

  refundFormInitialisation(
    userBankDetailsCountrySelect,
    USER_BANK_DETAILS_FORM_PER_COUNTRY,
    countryOfAuction,
    currentCountryName,
    false,
  )
});
